__turbopack_context__.v({
  "about": "Skills-module-scss-module__wpkeDG__about",
  "angular": "Skills-module-scss-module__wpkeDG__angular",
  "biome": "Skills-module-scss-module__wpkeDG__biome",
  "bootstrap": "Skills-module-scss-module__wpkeDG__bootstrap",
  "cardContainer": "Skills-module-scss-module__wpkeDG__cardContainer",
  "cardText": "Skills-module-scss-module__wpkeDG__cardText",
  "css": "Skills-module-scss-module__wpkeDG__css",
  "figma": "Skills-module-scss-module__wpkeDG__figma",
  "git": "Skills-module-scss-module__wpkeDG__git",
  "github": "Skills-module-scss-module__wpkeDG__github",
  "home": "Skills-module-scss-module__wpkeDG__home",
  "html": "Skills-module-scss-module__wpkeDG__html",
  "java": "Skills-module-scss-module__wpkeDG__java",
  "javascript": "Skills-module-scss-module__wpkeDG__javascript",
  "maven": "Skills-module-scss-module__wpkeDG__maven",
  "module-federation": "Skills-module-scss-module__wpkeDG__module-federation",
  "mysql": "Skills-module-scss-module__wpkeDG__mysql",
  "nextjs": "Skills-module-scss-module__wpkeDG__nextjs",
  "nodejs": "Skills-module-scss-module__wpkeDG__nodejs",
  "postman": "Skills-module-scss-module__wpkeDG__postman",
  "react": "Skills-module-scss-module__wpkeDG__react",
  "reactnative": "Skills-module-scss-module__wpkeDG__reactnative",
  "reactnavigation": "Skills-module-scss-module__wpkeDG__reactnavigation",
  "scss": "Skills-module-scss-module__wpkeDG__scss",
  "spring": "Skills-module-scss-module__wpkeDG__spring",
  "styled-components": "Skills-module-scss-module__wpkeDG__styled-components",
  "tailwindcss": "Skills-module-scss-module__wpkeDG__tailwindcss",
  "turborepo": "Skills-module-scss-module__wpkeDG__turborepo",
  "typescript": "Skills-module-scss-module__wpkeDG__typescript",
  "vercel": "Skills-module-scss-module__wpkeDG__vercel",
  "vite": "Skills-module-scss-module__wpkeDG__vite",
});
